export const API_URL = 'https://prod-api.enginebfai.com'
// export const API_URL =
//   'https://5a2zcecz87.execute-api.ap-southeast-1.amazonaws.com/prod_test_39_2'
